<script>
  import { Gamepad2, House, Orbit, Radio } from "@lucide/svelte";
</script>

<header class="top-bar command-nav">
  <button id="btn-nav-home" class="brand-lockup" type="button" aria-label="Asteroids Quest home">
    <span class="brand-mark" aria-hidden="true"><Orbit size={24} strokeWidth={1.6} /></span>
    <span class="brand-copy"><strong>ASTEROIDS</strong><span>QUEST</span></span>
  </button>

  <nav class="primary-nav" aria-label="Primary navigation">
    <button type="button" id="btn-nav-home-mobile" class="nav-link nav-home" aria-label="Home">
      <House size={17} aria-hidden="true" /><span>Home</span>
    </button>
    <button type="button" id="btn-nav-arcade" class="nav-link">
      <Gamepad2 size={17} aria-hidden="true" /><span>Arcade</span>
    </button>
    <button type="button" id="btn-nav-adventure" class="nav-link">
      <Orbit size={17} aria-hidden="true" /><span>Adventure</span>
    </button>
  </nav>

  <div class="system-state" aria-label="Server connection">
    <Radio size={15} aria-hidden="true" />
    <span>LIVE SYSTEM</span>
  </div>

  <div id="hud-stats" class="hud-stats hidden">
    <span id="hud-wave">WAVE 1</span>
    <span id="hud-ff" class="pill">FF OFF</span>
    <span id="hud-ping" class="dim">--ms</span>
    <button type="button" id="btn-mute" class="pill mute-btn" title="Toggle sound" aria-pressed="false">SFX ON</button>
  </div>
  <div id="campaign-hud" class="campaign-hud hidden" aria-label="Expedition resources">
    <span id="hud-objective" class="hud-objective">—</span>
    <span id="hud-fuel" class="pill res" title="Fuel">FUEL <b>0</b></span>
    <span id="hud-alloy" class="pill res" title="Alloy">ALLOY <b>0</b></span>
    <span id="hud-data" class="pill res" title="Data">DATA <b>0</b></span>
    <span id="hud-hull" class="pill res" title="Hull">HULL <b>0</b></span>
  </div>
</header>
